import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, OptionCardContent, ProgressBar } from '../../components/ui';

const OPTIONS = [
  {
    value: 'improve-body-shape',
    title: 'Improve body shape',
  },
  {
    value: 'clean-diet',
    title: 'Clean diet',
  },
  {
    value: 'skincare-routine',
    title: 'Skincare routine',
  },
  {
    value: 'better-posture',
    title: 'Better posture',
  },
  {
    value: 'look-taller',
    title: 'Look taller',
  },
  {
    value: 'sleep-better',
    title: 'Sleep better',
  },
];

export function ImproveMoreScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleToggle = (value: string) => {
    const current = onboarding.improvementGoals;
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    updateOnboarding({ improvementGoals: updated });
  };

  const handleContinue = () => {
    if (onboarding.improvementGoals.length > 0) {
      nextStep();
      navigate('/onboarding/appearance-anxiety');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={7} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">What else do you want to improve?</h1>
        <div className="mb-6" />

        <div className="space-y-3 mb-8">
          {OPTIONS.map(({ value, title }) => (
            <OptionCard
              key={value}
              selected={onboarding.improvementGoals.includes(value)}
              onClick={() => handleToggle(value)}
            >
              <OptionCardContent title={title} />
            </OptionCard>
          ))}
        </div>
      </div>

      <Button
        onClick={handleContinue}
        disabled={onboarding.improvementGoals.length === 0}
      >
        Continue
      </Button>
    </div>
  );
}
